import React, { useEffect, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { Play, User, LogOut, Radio, ShoppingBag } from 'lucide-react';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    checkLiveStatus();
    // Check every 30 seconds if live stream is active
    const interval = setInterval(checkLiveStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const checkLiveStatus = async () => {
    try {
      const response = await axios.get(`${API}/live/stream`);
      setIsLive(!!response.data);
    } catch (error) {
      setIsLive(false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav data-testid="navbar" className="sticky top-0 z-50 backdrop-blur-lg bg-slate-950/80 border-b border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <div className="w-10 h-10 bg-red-600 rounded flex items-center justify-center">
              <Play className="w-6 h-6 text-white" fill="white" />
            </div>
            <span className="text-xl font-bold text-white" style={{ fontFamily: 'Oswald, sans-serif', textTransform: 'uppercase' }}>
              Unfiltered Vision News
            </span>
          </Link>

          <div className="flex items-center space-x-6">
            <Link to="/videos" data-testid="videos-link" className="text-slate-300 hover:text-white">
              Videos
            </Link>
            {isLive ? (
              <Link to="/live-now" data-testid="live-now-link" className="relative">
                <div className="flex items-center gap-1 bg-red-600 text-white px-3 py-1 rounded-sm animate-pulse">
                  <Radio className="w-4 h-4" />
                  <span className="font-bold" style={{ fontFamily: 'Oswald, sans-serif' }}>LIVE NOW</span>
                </div>
              </Link>
            ) : (
              <Link to="/live" data-testid="live-link" className="text-slate-300 hover:text-white flex items-center gap-1">
                <Radio className="w-4 h-4" />
                Live
              </Link>
            )}
            <Link to="/merch" data-testid="merch-link" className="text-slate-300 hover:text-white flex items-center gap-1">
              <ShoppingBag className="w-4 h-4" />
              Merch
            </Link>
            <Link to="/pricing" data-testid="pricing-link" className="text-slate-300 hover:text-white">
              Pricing
            </Link>
            
            {user ? (
              <>
                <Link to="/dashboard" data-testid="dashboard-link">
                  <Button variant="ghost" size="sm" className="text-white">
                    <User className="w-4 h-4 mr-2" />
                    Dashboard
                  </Button>
                </Link>
                <Button 
                  data-testid="logout-button" 
                  onClick={handleLogout} 
                  variant="ghost" 
                  size="sm"
                  className="text-white"
                >
                  <LogOut className="w-4 h-4 mr-2" />
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="login-link">
                  <Button variant="ghost" size="sm" className="text-white">
                    Login
                  </Button>
                </Link>
                <Link to="/register" data-testid="register-link">
                  <Button data-testid="get-started-button" className="bg-red-600 hover:bg-red-700 text-white">
                    Get Started
                  </Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
